import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISuggestion } from './../../type-ahead.models';

@Component({
  selector: 'ns-type-ahead-suggestions',
  templateUrl: 'type-ahead-suggestions.component.html',
  styleUrls: ['type-ahead-suggestions.component.scss']
})
export class TypeAheadSuggestionsComponent {
  @Input() suggestions: ISuggestion<any>[];
  @Input() suggestIcon: string;
  @Output() selected = new EventEmitter<ISuggestion<any>>();
}
